import React from 'react';
import { motion } from 'framer-motion';
import useTranslation from '../hooks/useTranslation';
import './Ticker.css';

const Ticker = () => {
  const { t } = useTranslation();

  const words = t('ticker.words', { returnObjects: true }) || [
    'PRODUCTION', 'STORYTELLING', 'CREATIVE', 'CINEMATOGRAPHY', 
    'DIGITAL MARKETING', 'POST PRODUCTION', 'CONSULTING', 'MEDIA'
  ];

  const duplicatedWords = [...words, ...words, ...words, ...words];

  return (
    <div className="ticker-wrapper" dir="ltr">
      <motion.div 
        className="ticker-content"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ 
          duration: 60, 
          repeat: Infinity, 
          ease: "linear" 
        }}
      >
        {duplicatedWords.map((word, i) => (
          <span key={i} className="ticker-item">
            {word} <span className="ticker-dot">•</span>
          </span>
        ))}
      </motion.div>
    </div>
  );
};

export default Ticker;
